<template>
  <div>
    <cargo-advance-select
      ref="selectRef"
      :default-value="value"
      v-bind="params.selectProps"
      @visible-change="onBlur"
      @parentCallBack="valueChange"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
export default Vue.extend({
  name: 'CargoAgGridSelectEditor',
  components: { cargoAdvanceSelect },
  data() {
    return {
      value: ''
    }
  },
  mounted() {
    const { value } = this.params
    this.value = typeof value === 'boolean' ? String(value) : value
    this.$nextTick(() => {
      if (this.$refs.selectRef.$refs.advanceSelectRef) {
        this.$refs.selectRef.$refs.advanceSelectRef.focus()
      }
    })
  },
  methods: {
    getValue() {
      if (this.value === 'true') {
        return true
      }
      if (this.value === 'false') {
        return false
      }
      return this.value
    },
    onBlur(value) {
      if (!value) {
        this.params.api.stopEditing()
      }
    },
    valueChange(params) {
      this.value = params.value
    }
  }
})
</script>

<style scoped>
</style>
